/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive.ts";

function getGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveUrl(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams["discountTypeId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/editors/discount-types/${discountTypeId}/retroactive` as const,
  };
  return res;
}

/**
 * @description Migrado do legado RegistryAsync/GetRetroactiveDiscount. **(Requer Authorization para autenticação)**
 * @summary Indicador de desconto retroativo do tipo de desconto (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types/:discountTypeId/retroactive}
 */
export async function getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams["discountTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveUrl(
      discountTypeId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
